module.exports = "p{\r\n    font-size:1rem;\r\n    letter-spacing:.5px;\r\n    font-weight: 300;\r\n}"